import './styles.scss';

const CovidUpdateSection = () => {
  return (
    <div className="__CovidUpdateSection font_lato __my-container">
      <div className="__left-section">
        <h1 className="__title font_montserrat font-weight-bold __primary-text-color mb-4">Covid-19 Update</h1>
        {/*<h4 className='font_montserrat font-weight-normal __subtitle'>Posted by <span className='__primary-text-color font-weight-bold'>URBAIN</span>   |    Jan 15, 2021</h4>*/}
        <h3 className="font_montserrat font-weight-mediam-bold __primary-text-color __h3">
          Your well-being is our highest priority. Our carefully selected partners clean and sanitize our homes to exacting standards.
        </h3>
        <p className="__blog-paragraph">
          At Urbain, ensuring the well-being of our guests and homeowner partners is always our highest priority. To that end, we take a professional,
          no-compromise approach to health and safety that sets us apart from the amateur short-term rental market, employing market-leading
          procedures as part of our turn-key service, and acting in accordance with guidelines and recommendations issued by relevant public health
          authorities such as the U.S. Centers for Disease Control and the World Health Organization. Our professional and dedicated cleaning partners
          use a multi-point protocol to clean and sanitize each of our properties between each stay. Among other things, this protocol includes
          frequent cleaning and disinfecting of high-touch areas and hard surfaces as well as laundering towels and sheets at extreme high
          temperatures. Our cleaning personnel also electronically trace each element of the cleaning process, so that our guests and homeowner
          partners alike can be confident in the absolute cleanliness of our properties. Team members follow personal health and safety guidelines,
          including mask-wearing, frequent hand-washing, and social distancing. We do everything to ensure everyone can #staydelighted and stay
          safely.
        </p>
      </div>
    </div>
  );
};

export default CovidUpdateSection;
